// PERF TRACE (temporary, dev-only; see mobile-app/src/perf/README.md): Redux
// middleware that times every reducer pass and counts actions per lag window.
// store.js adds it ONLY when the bundle was built with EXPO_PUBLIC_PERF_TRACE=1
// (mobile perf-trace builds); the web app and store builds never set it.
const SLOW_MS = 8; // half a 60 Hz frame spent inside reducers
const now = () => (typeof performance !== 'undefined' && performance.now ? performance.now() : Date.now());

export const perfMiddleware = () => (next) => (action) => {
    const type = action && action.type;
    const t0 = now();
    const r = next(action);
    const ms = now() - t0;
    const win = (global.__PERF_WIN__ = global.__PERF_WIN__ || { fb: 0, fbBytes: 0, gps: 0, actions: 0, slowActions: 0 });
    win.actions += 1;
    if (type === 'UPDATE_GPS_LOCATION' || type === 'FETCH_BOOKING_LOCATION_SUCCESS') win.gps += 1;
    if (ms > SLOW_MS) {
        win.slowActions += 1;
        console.log('[PERF] ' + now().toFixed(1) + ' action:slow ' + JSON.stringify({ type, ms: Math.round(ms * 10) / 10 }));
    }
    return r;
};
